<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-robot`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M27 3a1 1 0 011 1v4a1 1 0 01-1 1h-1v4h13a2 2 0 012 2v26a2 2 0 01-2 2H9a2 2 0 01-2-2V15a2 2 0 012-2h13V9h-1a1 1 0 01-1-1V4a1 1 0 011-1h6zm10 14H11v22h26V17zM3 24a1 1 0 011 1v6a1 1 0 01-1 1H1a1 1 0 01-1-1v-6a1 1 0 011-1h2zm44 0a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zm-26 1v6h-6v-6h6zm12 0v6h-6v-6h6z"/></svg>
</template>
<script>

export default {
  name: 'IconRobot',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
